import { Col, Row, Space } from 'antd';
import React, { FC, ReactNode } from 'react';
import Container from 'components/StaticPageContainer';
import styles from './index.module.less';
import { Button } from 'components/Button';
import { TranslationKeys, useTypeSafeTranslation } from 'hooks';
import Link from 'next/link';
import { routes } from 'types/routes';
import { FeatureItem } from 'modules/HomePage/components/Feature';

const WIDGET_LIST: { title: TranslationKeys; text: TranslationKeys; icon: string }[] = [
  { title: 'about_us.fast', text: 'about_us.fast_content', icon: '/images/home/tachometer_fastest.png' },
  { title: 'about_us.secure', text: 'about_us.secure_content', icon: '/images/home/fingerprint.png' },
  { title: 'about_us.reliable', text: 'about_us.reliable_content', icon: '/images/home/fighter_jet.png' },
  // { title: 'homepage.why.liquid', text: 'homepage.why.liquid_content', icon: '/images/home/water.png' },
];

const FEATURE_LIST: { title: TranslationKeys; text: TranslationKeys; icon: string; alt: string }[] = [
  { title: 'about_us.spot', text: 'about_us.spot_content', icon: '/images/home/spot.png', alt: 'spot' },
  // {
  //   title: 'homepage.feature.margin',
  //   text: 'homepage.feature.margin_content',
  //   icon: '/images/home/margin.png',
  //   alt: 'margin',
  // },
  { title: 'about_us.staking', text: 'about_us.staking_content', icon: '/images/home/staking.png', alt: 'staking' },
  {
    title: 'about_us.devices',
    text: 'about_us.device_content',
    icon: '/images/home/mobile_app.png',
    alt: 'mobile_app',
  },
  { title: 'about_us.pro_tool', text: 'about_us.pro_tool_content', icon: '/images/home/pro_tool.png', alt: 'pro-tool' },
];

interface WidgetProps {
  text: string;
  title: string;
  icon: ReactNode;
}

const Widget: FC<WidgetProps> = ({ text, title, icon }) => {
  return (
    <div className={styles.widget}>
      {icon}
      <div className={styles.widgetSubtitle}>{text}</div>
      <div className={styles.widgetTitle}>{title}</div>
    </div>
  );
};

const AboutPage: FC = () => {
  const { t } = useTypeSafeTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.bg}>
        <div className={styles.circle1} />
        <div className={styles.circle2} />
      </div>
      <div className={styles.wrapper}>
        <Container size="xl">
          <div className={styles.header}>
            <h1>{t('about_us.about_us')}</h1>
            <div>{t('about_us.about_us_content')}</div>
          </div>
        </Container>
        {/* <Container size="lg">
          <Row className={styles.statistics} justify="space-around">
            <Col>
              <Statistic title="52" subtitle={t('about_us.crypto_listed')} />
            </Col>
            <Col>
              <Statistic title="1.2M" subtitle={t('about_us.users')} />
            </Col>
            <Col>
              <Statistic title="500K" subtitle={t('about_us.tx_per_minutes')} />
            </Col>
          </Row>
        </Container> */}

        <Container size="md">
          <div className={styles.my40}>
            <div className={styles.heading}>{t('about_us.team')}</div>
            {t('about_us.team_content')}
          </div>
          <div className={styles.my40}>
            <div className={styles.heading}>{t('about_us.philosophy')}</div>
            {t('about_us.philosophy_content')}
          </div>
          <div className={styles.my40}>
            <div className={styles.heading}>{t('about_us.support')}</div>
            {t('about_us.support_content')}
          </div>
          <div className={styles.my40}>
            <div className={styles.heading}>{t('about_us.why_ultorex')}</div>
            {t('about_us.why_ultorex_content')}
          </div>
        </Container>

        <Container size="xl">
          <div className={styles.my40}>
            <Row gutter={[24, 24]} justify="center">
              {WIDGET_LIST.map((widget, index) => (
                <Col key={index}>
                  <Widget
                    title={t(widget.title)}
                    text={t(widget.text)}
                    icon={<img className={styles.iconTop} alt="" src={widget.icon} />}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </Container>

        <Container size="xl">
          <div className={styles.my40}>
            <Row className={styles.hero}>
              <Col className={styles.heroCol}>
                <img className={styles.heroImage} alt="" src="/images/home/moon.png" />
              </Col>
              <Col className={styles.heroCol}>
                <h1 className={styles.heroTitle}>{t('homepage.hero.title_no_br')}</h1>
              </Col>
              <Col className={styles.heroCol}>
                <div className={styles.heroSubtitleWrap}>
                  <div className={styles.heroSubtitle}>{t('homepage.hero.subtitle')}</div>
                  <Link href={routes.exchange} passHref>
                    <Button size="large" className={styles.button} type="primary">
                      {t('homepage.hero.start_now')}
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>

          <Row className={styles.my40} justify="space-around" gutter={[24, 16]}>
            {FEATURE_LIST.map((feature, index) => (
              <React.Fragment key={index}>
                <FeatureItem
                  title={t(feature.title)}
                  text={t(feature.text)}
                  icon={<img className={styles.iconBottom} src={feature.icon} alt={feature.alt} />}
                />
              </React.Fragment>
            ))}
          </Row>
        </Container>
        <Container size="md">
          <Space direction="vertical">
            <div>{t('about_us.company')} Ultorex LLC</div>
            <div>{t('about_us.address')} Rockies,St. Vincent and the Grenadines</div>
            <div>CEO: Douglas Pilgrim</div>
          </Space>
        </Container>
      </div>
    </div>
  );
};

export default AboutPage;
